import React from 'react'
import { Link } from 'react-router-dom'
import { generatePath } from 'react-router'
import {
  Button,
  Image,
  Section,
  SupplierScoreMeter,
  RiskBox,
} from '../../components'
import NumberFormat from 'react-number-format'
import { ROUTE_PATH, STRING } from '../../helpers'
import { ICONS } from '../../themes'
import { copySync, truncate } from 'fs-extra'
import { toast } from 'react-toastify'
import { store } from 'store'

export class SupplierDiscoveryBlock extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      supplierList: [],
    }
  }

  addTolist = e => {
    this.props.supplierList(e)
  }

  toastSelect = () => {
    toast('Supplier was added successfully', {
      position: 'top-center',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      type: 'success',
    })
  }

  componentDidMount() {
    if (this.props.measure) {
      this.props.measure()
    }
  }

  checkNumberIsInteger = number => {
    if (Number.isInteger(number)) {
      return Math.floor(number)
    }
    return number
  }

  statusSupplier = status_supplier => {
    switch (status_supplier) {
      case 0:
        return <div className="status not-regis-status">Not Registered</div>
      case 1:
        return <div className="status active-status">Registered</div>
      case 2:
        return <div className="status registration-status">inActive</div>
      case 3:
        return (
          <div className="status wait-active-status">
            Waiting for registration
          </div>
        )
      default:
        return (
          <div className="status wait-active-status">
            Waiting for registration
          </div>
        )
    }
  }

  renderValueScoreMeter = number => {
    return number ? this.checkNumberIsInteger(number) : 'disabled'
  }

  render() {
    const { info } = this.props
    const blockKey = info.my_supplier_id || info.id
    const businessTypeLength = info.business_type.length
    // const list = [...selectsupplierList]
    const tooltipValue = () => {
      const score = Number(this.renderValueScoreMeter(info.risk_score)).toFixed(
        1
      )
      if (score < 2) {
        return score + ' ' + '/ 5.0 Very low risk'
      } else if (score < 3 && score > 1.9) {
        return score + ' ' + '/ 5.0 low risk'
      } else if (score < 4 && score > 2.9) {
        return score + ' ' + '/ 5.0 Medium risk'
      } else if (score < 5 && score > 3.9) {
        return score + ' ' + '/ 5.0 high risk'
      } else if (score > 4.9) {
        return score + ' ' + '/ 5.0 Very high risk'
      }
    }
    let statusCompany = ''
    switch (info.status_company) {
      case '1':
        statusCompany = 'ยังดำเนินกิจการอยู่'
        break
      case '2':
        statusCompany = 'พิทักษ์ทรัพย์เด็ดขาด'
        break
      case '3':
        statusCompany = 'แปรสภาพ'
        break
      case '4':
        statusCompany = 'เลิก'
        break
      case '5':
        statusCompany = 'เสร็จการชำระบัญชี'
        break
      case '6':
        statusCompany = 'ควบ'
        break
      case '7':
        statusCompany = 'ถอนหนังสือบริคณห์สนธิ'
        break
      case '8':
        statusCompany = 'ร้าง'
        break
      case '9':
        statusCompany = 'ล้มละลาย'
        break
      case 'A':
        statusCompany = 'ฟื้นฟู'
        break
      case 'B':
        statusCompany = 'คืนสู่ทะเบียน'
        break
      case 'D':
        statusCompany = 'สิ้นสภาพ'
        break
      default:
    }
    return (
      <>
        <Section className="supplier-discovery-block">
          <Section className="header-info">
            <Section className="info-wrapper">
              <div className="supplier-header">
                <div className="supplier-name-and-address">
                  <div className="supplier-name-and-signs">
                    <Link
                      className="supplier-name"
                      to={{
                        pathname: generatePath(
                          ROUTE_PATH.SUPPLIER_DISCOVERY_INFORMATION.LINK,
                          { id: info.my_supplier_id }
                        ),
                        state: { showButtonBack: true },
                      }}
                    >
                      {info.company_name}
                    </Link>

                    <Section className="signs">
                      <Button
                        className="link"
                        onClick={() => this.props.onIconClick(info)}
                      >
                        <Image
                          className="supplier-sign"
                          src={ICONS['icon-contact-sign.svg']}
                          alt="contact sign"
                        />
                      </Button>

                      {info.company_supplier_discovery_status === 2 && (
                        <Button
                          className="link"
                          onClick={() => this.props.onIconWarning(info)}
                        >
                          <Image
                            className="supplier-sign"
                            src={ICONS['icon-warning-sign.svg']}
                            alt="warning sign"
                          />
                        </Button>
                      )}
                      {!isNaN(info.status_supplier) &&
                        this.statusSupplier(info.status_supplier)}
                      {/* if not registered */}
                      {/* <div className="registration-status">Not Registered</div> */}
                    </Section>
                  </div>

                  <div className="supplier-address">
                    {`${
                      info.regis_address && info.regis_address !== '-'
                        ? info.regis_address
                        : 'N/A'
                    }`}
                  </div>
                </div>

                <div className="scoreboard">
                  {/* <SupplierScoreMeter
                    name="Risk"
                    value={this.renderValueScoreMeter(info.risk_score)}
                    alt={info.risk_score}
                    title={info.risk_score}
                    maxValue={5}
                    useTootipFor={'risk_score' + info.my_supplier_id}
                    useTootip={info.risk_score ? true : false}
                  /> */}
                  <RiskBox
                    useTootipFor={'risk-' + blockKey}
                    tootipValue={tooltipValue()}
                    useTooltip={true}
                    value={this.renderValueScoreMeter(info.risk_score)}
                    title="Risk Level"
                    score={Number(
                      this.renderValueScoreMeter(info.risk_score)
                    ).toFixed(1)}
                  />
                  {/* below is example */}
                  {/*<SupplierScoreMeter
                      name="Financial"
                      maxValue={5}
                      value={supplierInfo.financial}
                    />

                    <SupplierScoreMeter
                      name="Operational"
                      maxValue={5}
                      value={supplierInfo.financial}
                    />

                    <SupplierScoreMeter
                      name="Regulatory"
                      value="disabled"
                    />

                    <SupplierScoreMeter
                      name="Sustainability"
                      maxValue={5}
                      value={2}
                    />*/}

                  {/* {info.ss == 0 ? (
                    <SupplierScoreMeter
                      name="SS"
                      maxValue={0}
                      value="disabled"
                      alt=""
                    />
                  ) : (
                    <SupplierScoreMeter
                      name="SS"
                      maxValue={5}
                      value={info.ss}
                      alt={info.ss}
                      title={info.ss}
                    />
                  )} */}

                  {info.esg ? (
                    <div className="esg-score">
                      <div className="score">
                        {info.esg === 'InProgress' ? 'In progress' : info.esg}
                      </div>
                      <div className="label">{STRING.ESG}</div>
                    </div>
                  ) : null}
                </div>
              </div>
            </Section>
          </Section>

          <Section className="info-outer-wrapper">
            <Section className="info-wrapper">
              <div className="supplier-info">
                <div className="col">
                  <div className="info-block">
                    <div className="label">{STRING.TAX_ID}:</div>

                    <div className="data">
                      {info.tax_id == '' ? (
                        <div className="data">N/A</div>
                      ) : (
                        <div className="data">{info.tax_id}</div>
                      )}
                    </div>
                  </div>

                  <div className="info-block">
                    <div className="label">{STRING.STATUS}:</div>
                    {info.status_company.length == '' ||
                    info.status_company == '0' ? (
                      <div className="data">N/A</div>
                    ) : (
                      <div className="data">{`${statusCompany}`}</div>
                    )}
                  </div>
                  <div className="info-block">
                    <div className="label">{STRING.YEAR_ESTABLISHED}:</div>

                    <div className="data">
                      {info.year_established ? info.year_established : 'N/A'}
                    </div>
                  </div>
                </div>

                <div className="col">
                  <div className="info-block">
                    <div className="label">{STRING.BRANCH}:</div>

                    {info.branch == '' ? (
                      <div className="data">N/A</div>
                    ) : (
                      <div className="data">{info.branch}</div>
                    )}
                  </div>
                  <div className="info-block">
                    <div className="label">{STRING.BUSINESS_TYPE}:</div>
                    {info.business_type.length == '' ? (
                      <div className="data">N/A</div>
                    ) : (
                      <div className="data">
                        {info.business_type.map((businessType, i) =>
                          businessTypeLength === i + 1
                            ? businessType.business_type_name
                            : businessType.business_type_name + ', '
                        )}
                      </div>
                    )}
                  </div>
                  <div className="info-block">
                    <div className="label">{STRING.REGISTERED_CAPITAL}:</div>

                    <div className="data">
                      {info.regis_capital > -1 ? (
                        <>
                          <NumberFormat
                            value={info.regis_capital}
                            displayType={'text'}
                            thousandSeparator={true}
                          />
                          {` ${info.currency.name}`}
                        </>
                      ) : (
                        'N/A'
                      )}
                    </div>
                  </div>
                </div>

                <div className="col fluid">
                  <div className="info-block">
                    <div className="label">{STRING.SERVICE_CATEGORY}:</div>
                    <div className="data">
                      {info.service_category &&
                        info.service_category.map((item, index) => (
                          <span
                            key={`${item.category_id}-${item.sub_category_id}-${index}`}
                          >
                            <div>
                              {/* {`${item.category_name} > ${item.sub_category_name}`} */}
                              {item.category_name}&nbsp;
                              {item.sub_category_name !== '' ? '>' : null}&nbsp;
                              {item.sub_category_name}
                            </div>
                          </span>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </Section>

            {/* <Section className="actions">
              {console.log('MY : ', list)}
              {console.log('info : ', info)}
              {
                // console.log(e)
                list.find(e => e.my_supplier.tax_id === info.tax_id) ? (
                  <Button
                    disabled={true}
                    className="theme-blue"
                    onClick={() => {
                      console.log(info)
                    }}
                  >
                    Selected
                  </Button>
                ) : (
                  <Button
                    className="theme-blue"
                    onClick={() => {
                      this.addTolist(info)
                    }}
                  >
                    Select
                  </Button>
                )
              }

              <Button className="theme-blue">Invite to Buyer portal</Button>
            </Section> */}
          </Section>
        </Section>
      </>
    )
  }
}
